export default "__VITE_ASSET__DhCQQrCb__"